// 商店管理
export default [
  {
    path: '/postHouseStore/findPostHouseStoreList',
    name: 'findPostHouseStoreList',
    meta: {
      title: '商店管理'
    },
    component: () => import('@/views/postManagement/storeManagement.vue')
  },
  {
    path: '/postHouseStore/savePostHouseStore',
    name: 'savePostHouseStore',
    meta: {
      title: '添加循环商店'
    },
    component: () => import('@/views/postManagement/addStore.vue')
  }

]
